import store from '@/store'
import dictList from '@/store/dict.js'

const funcDict = {
	'数学': [{
		name: 'ABS',
		desc: '返回传入数值的绝对值',
		params: 'ABS(value)',
		fun(value) {
			try {
				return Math.abs(value) || 0;
			} catch(e) {
				console.error('ABS', e, arguments);
				return 0;
			}
		}
	}, {
		name: 'CEIL',
		desc: '返回传入数值向上取整后的值',
		params: 'CEIL(value)',
		fun(value) {
			try {
				return Math.ceil(value) || 0;
			} catch(e) {
				console.error('CEIL', e, arguments);
				return 0;
			}
		}
	}, {
		name: 'FLOOR',
		desc: '返回传入数值向下取整后的值',
		params: 'FLOOR(value)',
		fun(value) {
			try {
				return Math.floor(value) || 0;
			} catch(e) {
				console.error('FLOOR', e, arguments);
				return 0;
			}
		}
	}, {
		name: 'ROUND',
		desc: '按四舍五入规则对数值进行取整',
		params: 'ROUND(value)',
		fun(value) {
			try {
				return Math.round(value) || 0;
			} catch(e) {
				console.error('ROUND', e, arguments);
				return 0;
			}
		}
	}, {
		name: 'MAX',
		desc: '返回传入的多个数值当中最大的值',
		params: 'MAX(value1, value2, ...valueN)',
		fun(...values) {
			try {
				return Math.max.apply(Math, values) || 0;
			} catch(e) {
				console.error('MAX', e, arguments);
				return 0;
			}
		}
	}, {
		name: 'MIN',
		desc: '返回传入的多个数值当中最小的值',
		params: 'MIN(value1, value2, ...valueN)',
		fun(...values) {
			try {
				return Math.min.apply(Math, values) || 0;
			} catch(e) {
				console.error('MIN', e, arguments);
				return 0;
			}
		}
	}],
	'日期': [{
		name: 'DAYS',
		desc: '返回结束日期和开始日期之间的天数',
		params: 'DAYS(endDate, startDate)',
		fun(end, start) {
			try {
				return (new Date(end.split(' ')[0]).getTime() - new Date(start.split(' ')[0]).getTime()) / 86400000 || 0;
			} catch(e) {
				console.error('DAYS', e, arguments);
				return 0;
			}
		}
	}],
	'逻辑': [{
		name: 'IF',
		desc: '返回条件为真时返回的值，否则返回另一个值',
		params: 'IF(logic, if_value, else_value)',
		fun(logic, val1, val2) {
			try {
				return logic ? val1 : val2;
			} catch(e) {
				console.error('IF', e, arguments);
				return val2;
			}
		}
	// }, {
	// 	name: 'IFS',
	// 	desc: '返回第一个为真的条件所对应的值，所有条件都为假则返回最后一个值',
	// 	params: 'IFS(logic1, if_value1, ...logicN, if_valueN, else_value)',
	// 	fun(...params) {
	// 		try {
	// 			let i;
	// 			for (i = 0; i < params.length - 1; i += 2) {
	// 				if (params[i]) return params[i + 1];
	// 			}
	// 			return params[i];
	// 		} catch(e) {
	// 			console.error('IFS', e, arguments);
	// 			return params[params.length - 1];
	// 		}
	// 	}
	}, {
		name: 'INCLUDES',
		desc: '判断一个或一组数值是否包含另一个数值',
		params: 'INCLUDES(values, value)',
		fun(vals, val) {
			try {
				if (Array.isArray(vals)) {
					return vals.findIndex(item => item.toString() == val.toString()) != -1;
				} else {
					return vals.toString().includes(val);
				}
			} catch(e) {
				console.error('INCLUDES', e, arguments);
				return false;
			}
		}
	}]
};

const names = [];
const funcs = [];
Object.keys(funcDict).forEach(group => {
	funcDict[group].forEach(item => {
		names.push(item.name);
		funcs.push(item.fun);
	});
});

function parseFormula(formula, data, opt = {}) {
	try {
		let field = formula.match(/\$\{[^\{\}]*\}/g) || [];
		field.forEach(item => {
			let str = item.match(/[^\$\{\.\}]+/g);
			try {
				let dict = store.state.formulaDict[str.join('.')];
				let val = data[str[0]] ? data[str[0]][dict.field_code] : '';
				let type = dict.field_type == 9 ? {
					text: 1,
					number: 2,
					time: 3,
					option: 4,
					file: 5,
					image: 6
				}[dict.config_json.type] : dict.field_type;

				if (val === undefined || val === null) {
					val = '';
				}

				if (type == 2) {
					val = parseFloat(val) || 0;
				} else if (dict.field_type == 4) {
					if (dict.config_json.dict_config.dictType == 'PAGEDIC') {
						try {
							val = `'${dictList[dict.config_json.dict_config.dictName].find(item => item.value == val).name}'`;
						} catch(e) {
							val = `'${val}'`;
						}
					} else if (dict.config_json.dict_config.dictType == 'DBDIC') {
						val = `'${val}'`;
					}
				} else {
					val = `'${val}'`;
				}

				formula = formula.replaceAll(item, val);
			} catch(e) {
				console.error(e);
				formula = formula.replaceAll(item, '\'\'');
			}
		});
	} catch(e) {
		console.error('公式字段解析异常\n', e);
	}
	
	try {
		formula = formula.replace(/(if\s*\([^)]+\)\s*\{\s*)(\S*?)/g, '$1 return $2').replace(/(else\s*\{\s*)(\S*?)/g, '$1 return $2');
		let value = new Function(...names, (formula.includes('return') ? '' : 'return ') + formula).apply(null, funcs);
		if (opt.valueType == 'number') {
			value = parseFloat(value);
			value = value != value ? '' : value;
		} else if (opt.valueType == 'time') {
			value = /^(?:(?:\d{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12]\d|3[01]))(?: (?:(?:[01]\d|2[0-3])(?::(?:[0-5]\d)(?::(?:[0-5]\d))?)?)?)?|(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d)$/.test(value)
				? value
				: '';
		}
		opt.success && opt.success();
		return value;
	} catch(e) {
		opt.fail && opt.fail();
		console.error('公式运行异常\n', e);
	}

	return '';
}

export {
	funcDict,
	parseFormula
}